import { render, staticRenderFns } from "./NewestPractices.vue?vue&type=template&id=0cdb88f9&scoped=true&"
import script from "./NewestPractices.vue?vue&type=script&lang=ts&"
export * from "./NewestPractices.vue?vue&type=script&lang=ts&"
import style0 from "./NewestPractices.vue?vue&type=style&index=0&id=0cdb88f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdb88f9",
  null
  
)

export default component.exports